<template>
  <el-container>
    <el-aside width="100%">
      <el-container>
        <el-header>
          <el-form :inline="true">
            <el-form-item label="时间：">
              <el-date-picker v-model="queryParam.dateRange" type="daterange" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" class="date-range" range-separator="至"
                :editable="false" :clearable="true"></el-date-picker>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select v-model="queryParam.CheckFlag" :clearable="true">
                <el-option value="0" label="待确认"></el-option>
                <el-option value="1" label="生效"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓库：" v-if="$store.state.routes.systemSetting.MultiWarehouse">
              <warehouse-select :value.sync="queryParam.WID" select_style="width:125px;"></warehouse-select>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button type="default" @click="reset()">重置</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item class="action-button">
              <el-form-item>
                <el-button  type="primary" @click="handleAdd" :loading="addLoading">开始盘点</el-button>
              </el-form-item>
              <el-form-item>
                <el-dropdown @command="handleExportAll">
                  <el-button type="primary" plain>
                    全盘盘点
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="Export">导出全部商品库存</el-dropdown-item>
                    <el-dropdown-item command="Import">导入并创建盘点单</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-upload style="display: none" ref="importXls" accept=".xls,.xlxs" :action="xlsData.uploadUrl"
                  :show-file-list="false" class="div-upload" :headers="xlsData.headers" :multiple="false"
                  :on-success="uploadXlsSuccess" :on-error="uploadXlsError" :before-upload="uploadXlsBefore" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" plain @click="otherInventoryVisible = true">导入盘点</el-button>
                <el-dialog :visible="otherInventoryVisible" title="导入盘点" @close="otherInventoryVisible = false"
                  :close-on-click-modal="false" width="500px">
                  <div class="xls-import">
                    <el-upload drag ref="importOtherXls" accept=".xls,.xlxs" :action="xlsData.uploadOtherUrl"
                      :auto-upload="false" :show-file-list="true" :headers="xlsData.headers" :multiple="false"
                      :on-success="uploadXlsSuccess" :on-error="uploadXlsError" :before-upload="uploadXlsBefore"
                      :on-change="handleOtherInventoryFileChange">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或
                        <em>点击上传</em>
                      </div>
                      <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
                    </el-upload>
                  </div>

                  <div slot="footer" class="dialog-footer">
                    <el-button type="success" size="small" @click="handleOtherInventoryDownXls">下载模板</el-button>
                    <el-button type="primary" size="small" @click="handleOtherInventoryImport">导入</el-button>
                    <el-button @click="otherInventoryVisible = false">取消</el-button>
                  </div>
                </el-dialog>
              </el-form-item>
            </el-form-item>
          </el-form>
        </el-header>
        <el-main>
          <grid-table ref="gridTable" :showIndexColumn="false" :showLastEmptyColumn="false" :showPagination="true"
            :tableConfig="tableConfig" @selectionChange="handleSelectionChange" @handleRowClick="handleRowClick"
            :resizable="false"></grid-table>
        </el-main>
      </el-container>
    </el-aside>
    <inventory-detail ref="inventoryDetail" @refresh="handleQuery"></inventory-detail>
  </el-container>
</template>

<script>
import { submit, exportFile } from '@/api/base'
import { baseURL, successCode } from '@/config'
import dayjs from 'dayjs'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
import InventoryDetail from '@/views/wms/inventory/components/InventoryDetail.vue'
export default {
  name: 'pageList',
  components: { WarehouseSelect, InventoryDetail },
  data() {
    return {
      routeParam: {},
      tableConfig: {
        url: '/api/wms/inventory/getList',
        rowKey: 'InventoryID',
        columns: [
          {
            label: '盘点日期',
            prop: 'RecordAddTime',
            type: 'text',
            width: '180px',
          },
          {
            label: '盘点单号',
            prop: 'InventoryCode',
            type: 'text',
            width: '200px',
          },
          {
            label: '盘点仓库',
            prop: 'WName',
            type: 'text',
          },
          {
            label: '盘点状态',
            prop: 'StatusText',
            type: 'text',
            width: '130px',
          },
          {
            label: '盘点结果',
            prop: 'Result',
            type: 'text',
          },
        ],
      },
      queryParam: {
        CheckFlag: undefined,
        dateRange: [],
        WID: 0,
      },
      addLoading: false,
      selectRows: [],
      xlsData: {
        loading: null,
        uploadUrl: `${baseURL}/api/wms/inventory/importInventoryDetail`,
        uploadOtherUrl: `${baseURL}/api/wms/inventory/importOtherInventoryDetail`,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters['user/accessToken'],
        },
        isAll: false,
        isOther: false,
      },
      otherInventoryVisible: false,
      otherInventoryFile: null,
    }
  },
  mounted() {
    this.handleQuery()
  },
  methods: {
    handleOtherInventoryFileChange(file) {
      this.otherInventoryFile = file
    },
    // 其他盘点下载模板
    async handleOtherInventoryDownXls() {
      const today = dayjs().format('YYYYMMDDHHmmss')
      var excelName = '盘点导入模版_' + today + '.xls'
      await this.baseExport(excelName, '/api/wms/inventory/exportOtherTemplete')
    },

    // 其他盘点导入
    handleOtherInventoryImport() {
      // 获取上传的文件列表
      const fileList = this.$refs.importOtherXls.uploadFiles
      if (!fileList || fileList.length === 0) {
        this.$message({
          type: 'warning',
          message: '请先选择要上传的文件',
        })
        return
      }

      this.xlsData.isOther = true
      this.$confirm('确认导入并创建盘点单?', '导入盘点', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 手动触发上传
          this.$refs.importOtherXls.submit()
          this.otherInventoryVisible = false
        })
        .catch(() => {
          //取消
        })
    },
    reset() {
      this.queryParam.dateRange = []
      this.queryParam.CheckFlag = undefined
      this.queryParam.WID = undefined
      this.handleQuery()
    },
    async handleExportAll(command) {
      if (command == 'Export') {
        const today = dayjs().format('YYYYMMDDHHmmss')
        var excelName = '盘前商品库存_' + today + '.xls'
        await this.baseExport(excelName, '/api/wms/inventory/export', { ExportProductStocks: true })
      } else if (command == 'Import') {
        this.xlsData.isAll = true
        this.$confirm('确认导入并创建盘点单?', '全盘盘点', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.$refs['importXls'].$refs['upload-inner'].handleClick()
          })
          .catch(() => {
            //取消
          })
      }
    },
    async baseExport(excelName, url, param) {
      const { data } = await exportFile(url, param)
      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = excelName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    uploadXlsSuccess(res) {
      if (successCode.includes(res.code)) {
        this.$message({ type: 'success', message: res.msg })
      } else {
        this.$message({ type: 'error', message: '导入错误：' + res.msg })
      }
      if (this.xlsData.isOther) {
        this.$refs.importOtherXls.clearFiles()
      } else {
        this.$refs.importXls.clearFiles()
      }
      this.xlsData.isAll = false
      this.xlsData.isOther = false
      if (this.xlsData.loading != null) {
        this.xlsData.loading.close()
      }
      this.xlsData.loading = null
      this.$refs.inventoryDetail.open({ InventoryID: res.data, CheckFlag: 0 })
    },
    uploadXlsError() {
      this.xlsData.isAll = false
      this.xlsData.isOther = false
      this.$message({ type: 'error', message: '导入失败' })
      if (this.xlsData.loading != null) {
        this.xlsData.loading.close()
      }
      this.xlsData.loading = null
    },
    uploadXlsBefore(file) {
      this.xlsData.loading = this.$loading({
        lock: true,
        text: '正在导入中......',
      })
    },
    handleSelectionChange(selection) {
      this.selectRows = selection
      if (selection.length <= 0) {
        if (this.$refs.inventoryDetail) {
          this.$refs.inventoryDetail.reset()
        }
      }
    },
    handleRowClick(row) {
      this.$refs.gridTable.$refs.gridTable.clearSelection()
      this.$refs.gridTable.$refs.gridTable.toggleRowSelection(row)
      this.$refs.inventoryDetail.open(row)
    },
    handleAdd() {
      this.$refs.inventoryDetail.add()
    },
    handleQuery() {
      this.$refs.gridTable.searchParam = { ...this.queryParam }
      if (this.queryParam.dateRange && this.queryParam.dateRange.length > 0) {
        this.$refs.gridTable.searchParam.TimeStart = this.queryParam.dateRange[0]
        this.$refs.gridTable.searchParam.TimeEnd = this.queryParam.dateRange[1]
      } else {
        this.$refs.gridTable.searchParam.TimeStart = ''
        this.$refs.gridTable.searchParam.TimeEnd = ''
      }
      delete this.$refs.gridTable.searchParam.dateRange
      this.$refs.gridTable.fetchData()
      if (this.$refs.inventoryDetail) {
        this.$refs.inventoryDetail.reset()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-header {
    height: 54px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px 0 !important;

    .el-form {
      .el-form-item {
        margin-bottom: 5px !important;

        &.action-button {
          position: absolute;
          right: 0;
        }
      }
    }
  }
  .el-aside {
    .el-select {
      width: 100px;
      margin-right: 5px;
    }

    .date-range {
      width: 210px;

      ::v-deep {
        .el-range-input {
          width: 70px;
        }
      }
    }

    .el-radio {
      margin-right: 10px;
    }

    .el-form-item__label {
      padding-right: 0;
    }
  }
}

.xls-import {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
</style>
